/**
 * Ошибка из-за отсутствия сети / недоступности хоста (axios без response).
 */
export function isLikelyOfflineOrNetworkError(error) {
    if (typeof navigator !== "undefined" && !navigator.onLine) {
        return true;
    }
    if (error?.code === "ERR_NETWORK" || error?.code === "ECONNABORTED") {
        return true;
    }
    if (!error?.response && error?.request) {
        return true;
    }
    return false;
}
